// utils/fetchQuote.js
export async function fetchQuote(modelCode) {
  const base = process.env.REACT_APP_STATIC_BASE || "";
  const code = String(modelCode || "").trim();

  const candidates = [
    `${base}/demo/3dmodels/quote_${code}.json`,
    `${base}/demo/3dmodels/offer_${code}.json`,
    `${base}/demo/3dmodels/${code}/quote.json`,
    `${base}/demo/3dmodels/${code}/offer.json`,
    `${base}/demo/3dmodels/${code}.quote.json`,
    `${base}/demo/3dmodels/${code}.offer.json`,
  ];

  for (const url of candidates) {
    try {
      const res = await fetch(url, { cache: "no-store" });
      console.log("fetchQuote try:", url, res?.status);
      if (!res.ok) continue;
      const txt = await res.text();
      const json = JSON.parse(txt);
      console.log("✅ fetchQuote OK:", url);
      // za lakši debug u konzoli
      window.__lastQuoteUrl = url;
      window.__lastQuoteRaw = json;
      return json;
    } catch (e) {
      console.warn("fetchQuote parse/fetch fail for", url, e);
    }
  }

  console.warn("❌ Nije nađen nijedan quote/offer fajl za", code, "kandidati:", candidates);
  return null;
}
